import { inputBaseClasses } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const muiInputBaseComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid ${theme.palette.main.professional_blue}`,
      borderRadius: '4px',
      fontFamily: '"Circular TT", "Arial", sans-serif',
      padding: '0',

      [`&.Mui-focused`]: {
        boxShadow: theme.shadows[5],
      },

      [`&.Mui-error`]: {
        borderColor: theme.palette.error.main,
      },

      [`&.Mui-disabled`]: {
        backgroundColor: theme.palette.gray.light_gray,
        borderColor: theme.palette.gray.gray,
        textFillColor: theme.palette.gray.gray,
      },
    }),
    input: ({ theme }) => ({
      boxSizing: 'border-box',
      color: theme.palette.main.professional_blue,
      height: theme.spacing('5XL'),
      padding: `${theme.spacing('LARGE')} ${theme.spacing('MEDIUM')}}`,

      [`&::placeholder`]: {
        color: theme.palette.main.product_blue,
        opacity: 1,
      },

      [`&[type='number']::-webkit-inner-spin-button, &[type='number']::-webkit-outer-spin-button`]:
        {
          appearance: 'none',
          margin: 0,
        },
    }),
    formControl: () => ({}),
    hiddenLabel: {
      paddingTop: 0,
    },
    multiline: ({ theme }) => ({
      padding: 0,

      [`.${inputBaseClasses.input}`]: {
        padding: theme.spacing('LARGE'),
      },
    }),
  },
};
